export const BILLING_CYCLE = ['annual', 'monthly'] as const;
export type BillingCycle = 'annual' | 'monthly';
